import { friendAvatar } from "utils/assets_exports/images";
import UserPopover from "./UserPopover";

const PostUserBlock = () => {
    return (
        <div className="user-block">
            <div className="image p-relative">
                <img src={friendAvatar} data-user-popover="1" alt="" />
                <UserPopover />
            </div>
            <div className="user-info">
                <a href="#">Dan Walker</a>
                <span className="time">July 26 2018, 01:03pm</span>
            </div>
        </div>
    );
};

export default PostUserBlock;
